var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"bg-box"},[_c('div',{staticClass:"ifame-box"},[_c('iframe',{attrs:{"id":"frameDom","name":"frame","src":_vm.getTestUrl,"frameborder":"0","width":"100%","height":"100%"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }